// extracted by mini-css-extract-plugin
export default {"primary":"button_primary__xCidC","outline":"button_outline__2Hfu-","button-push":"button_button-push__MtJL-","secondary":"button_secondary__KbRTr","counter":"button_counter__OjkHp"};